export const CLEAN_DNI = /^0+|[^0-9kK]+/g
export const CURRENCY_DOTS = /(\d)(?=(?:[0-9,]{3})+\b)/g
export const PATH_PARAM = /:\w+(?=\/?)/
export const FILTER_PATTERN_CHECK = /[\u0300-\u036f]/g
